import { OnInit, Component, ViewEncapsulation } from "@angular/core";


@Component({
    selector: "app-content",
    templateUrl: "./content.component.html",
    encapsulation: ViewEncapsulation.None
})
export class ContentComponent implements OnInit{

    ngOnInit(): void {

    }
}


